import request from '@/utils/request'

/**
 * 联系我们 - 提交表单
 * @param {Object} data 表单数据
 * @param {string} data.companyName 公司名称
 * @param {string} data.callName 姓名
 * @param {string} data.phone 联系方式
 * @param {string} data.businessName 业务形式
 * @param {number} [data.id] id（可选）
 * @returns {Promise}
 */
export function saveCallUs(data) {
  return request({
    url: '/api/call-us/save',
    method: 'post',
    data
  })
}

